module.exports = __webpack_public_path__ + "img/control-switch-on.dc15075c.svg";